<template lang="pug">
.no-work-orders.mt-20.text-center
  img.my-15(
    :src="IMAGE_WORK_ORDER"
    alt="No work orders"
    width="100"
  )
  h5.my-0
    | You have no work orders
  AppButton.mt-20(
    type="primary"
    @click="$emit('add-work-order')"
  )
    | Add work order
</template>
<script>
import { IMAGE_WORK_ORDER } from '~/rails_assets';

export default {
  data: () => ({
    IMAGE_WORK_ORDER,
  }),
};
</script>
